<template>
    <main class="sustainability-view">
        <header class="cover sustainability-cover">
            <div class="cover-bg" :style="styles.coverBg" v-parallax="0.3"></div>
            <div class="cover-content" v-parallax="0.15">
                <h1 class="cover-title">{{ $t('pages.sustainability.title') }}</h1>
                <h2 class="cover-subtitle">{{ $t('pages.sustainability.subtitle') }}</h2>
            </div>
        </header>
        <div class="body">
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#green-energy', 'down')"></v-waypoint>
                <div id="green-energy" class="text-block text-block-01">
                    <h3 class="text-block-title text-block-title-underline">{{ $t('pages.sustainability.text-block-01.title') }}</h3>
                    <div class="text-block-body">
                        <p v-html="$t('pages.sustainability.text-block-01.body')"></p>
                    </div>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#green-energy', 'up')"></v-waypoint>
            </section>
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#powering-future', 'down')"></v-waypoint>
                <div class="image-block image-block-01">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image01.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image01.md}`" />
                        <img :src="`${assets.image01.xs}`"/>
                    </picture>
                </div>
                <div id="powering-future" class="text-block text-block-02">
                    <h3 class="text-block-title text-block-title-underline">{{ $t('pages.sustainability.text-block-02.title') }}</h3>
                    <div class="text-block-body">
                        <p v-html="$t('pages.sustainability.text-block-02.body')"></p>
                    </div>
                </div>
                <div class="image-block image-block-02">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image02.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image02.md}`" />
                        <img :src="`${assets.image02.xs}`"/>
                    </picture>
                </div>
                <div class="image-block image-block-03">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image03.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image03.md}`" />
                        <img :src="`${assets.image03.xs}`"/>
                    </picture>
                </div>
                <div class="image-block image-block-04">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image04.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image04.md}`" />
                        <img :src="`${assets.image04.xs}`"/>
                    </picture>
                </div>
                <div class="text-block text-block-03">
                    <div class="text-block-body">
                        <p v-html="$t('pages.sustainability.text-block-03.body')"></p>
                    </div>
                </div>
                <div class="image-block image-block-05">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image05.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image05.md}`" />
                        <img :src="`${assets.image05.xs}`"/>
                    </picture>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#powering-future', 'up')"></v-waypoint>
            </section>
        </div>
        <in-page-nav :links="inPageLinks" :active="inPageNavActive" />
    </main>
</template>

<script>
  import InPageNav from '../widgets/InPageNav.vue'
  import getMatchedBreakpoint from '../mixins/getMatchedBreakpoint'
  import updateHead from '../mixins/updateHead'
  import updateInPageNav from '../mixins/updateInPageNav'

  export default {
    computed: {
      styles () {
        return {
          coverBg: {
            backgroundImage: `url(${this.assets.cover[this.matchedBreakpoint]})`
          }
        }
      },
      assets () {
        return {
          cover: {
            xs: this.$t('pages.sustainability.cover.xs'),
            md: this.$t('pages.sustainability.cover.md'),
            xl: this.$t('pages.sustainability.cover.xl')
          },
          image01: {
            xs: this.$t('pages.sustainability.image-block-01.xs'),
            md: this.$t('pages.sustainability.image-block-01.md'),
            xl: this.$t('pages.sustainability.image-block-01.xl')
          },
          image02: {
            xs: this.$t('pages.sustainability.image-block-02.xs'),
            md: this.$t('pages.sustainability.image-block-02.md'),
            xl: this.$t('pages.sustainability.image-block-02.xl')
          },
          image03: {
            xs: this.$t('pages.sustainability.image-block-03.xs'),
            md: this.$t('pages.sustainability.image-block-03.md'),
            xl: this.$t('pages.sustainability.image-block-03.xl')
          },
          image04: {
            xs: this.$t('pages.sustainability.image-block-04.xs'),
            md: this.$t('pages.sustainability.image-block-04.md'),
            xl: this.$t('pages.sustainability.image-block-04.xl')
          },
          image05: {
            xs: this.$t('pages.sustainability.image-block-05.xs'),
            md: this.$t('pages.sustainability.image-block-05.md'),
            xl: this.$t('pages.sustainability.image-block-05.xl')
          }
        }
      },
      inPageLinks () {
        return [
          {
            title: this.$t('pages.sustainability.text-block-01.title'),
            hash: '#green-energy'
          },
          {
            title: this.$t('pages.sustainability.text-block-02.title'),
            hash: '#powering-future'
          }
        ]
      }
    },
    head: {
      title () {
        return {
          inner: this.$t('pages.sustainability.title'),
          complement: this.$t('common.ruyi-group')
        }
      }
    },
    components: {
      InPageNav
    },
    mixins: [
      getMatchedBreakpoint,
      updateHead,
      updateInPageNav
    ]
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .sustainability-view {
        .text-block {
            &-01 {
                .text-block-body {
                    width: px2rem(280px);

                    @include media-breakpoint-up(md) {
                        width: auto;
                    }
                }
            }

            &-02 {
                @include media-breakpoint-up(md) {
                    border: 1px solid $black;
                    margin-left: px2rem(275px);
                    margin-right: px2rem(50px);
                    margin-top: px2rem(-70px);
                    padding-bottom: px2rem(45px);
                    padding-top: px2rem(105px);
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(450px);
                    margin-right: px2rem(80px);
                    margin-top: px2rem(-90px);
                    padding-bottom: px2rem(90px);
                    padding-top: px2rem(135px);
                }

                .text-block-title {
                    @include media-breakpoint-up(md) {
                        left: 50%;
                        position: absolute;
                        transform: translateY(-200px);
                    }

                    @include media-breakpoint-up(xl) {
                        position: absolute;
                        transform: translateY(-330px);
                    }
                }

                .text-block-body {
                    width: px2rem(280px);

                    @include media-breakpoint-up(md) {
                        max-width: px2rem(420px);
                        min-width: px2rem(280px);
                        width: calc(100% - 160px);
                    }

                    @include media-breakpoint-up(xl) {
                        max-width: px2rem(720px);
                        min-width: px2rem(480px);
                    }
                }
            }

            &-03 {
                @include media-breakpoint-up(md) {
                    border: 1px solid $black;
                    margin-left: px2rem(250px);
                    margin-right: px2rem(100px);
                    margin-top: px2rem(-160px);
                    padding-left: px2rem(90px);
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(420px);
                    margin-right: px2rem(160px);
                    margin-top: px2rem(-280px);
                    padding-bottom: px2rem(120px);
                    padding-top: px2rem(120px);
                }

                .text-block-body {
                    width: px2rem(280px);

                    @include media-breakpoint-up(md) {
                        max-width: px2rem(420px);
                        min-width: px2rem(280px);
                        width: calc(100% - 160px);
                    }

                    @include media-breakpoint-up(xl) {
                        min-width: px2rem(360px);
                        max-width: px2rem(540px);
                        width: calc(100% - 240px);
                    }
                }
            }
        }

        .image-block {
            &-01 {
                @include media-breakpoint-up(md) {
                    width: px2rem(471px);
                }

                @include media-breakpoint-up(xl) {
                    width: px2rem(786px);
                }
            }

            &-02 {
                width: 65%;

                @include media-breakpoint-up(md) {
                    margin-left: auto;
                    margin-top: px2rem(-50px);
                    width: px2rem(138px);
                }

                @include media-breakpoint-up(xl) {
                    margin-top: px2rem(-75px);
                    width: px2rem(230px);
                }
            }

            &-03 {
                @include media-breakpoint-up(md) {
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: px2rem(-100px);
                    width: px2rem(579px);
                }

                @include media-breakpoint-up(xl) {
                    width: px2rem(964px);
                }
            }

            &-04 {
                margin-left: auto;
                margin-top: px2rem(-80px);
                width: 65%;

                @include media-breakpoint-up(md) {
                    margin-left: 0;
                    margin-top: px2rem(100px);
                    width: px2rem(332px);
                }

                @include media-breakpoint-up(xl) {
                    width: px2rem(555px);
                }
            }

            &-05 {
                @include media-breakpoint-up(md) {
                    margin-top: px2rem(100px);
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Sustainability.vue?255b2f80